/**
 * src/components/admin/adminUpload.js
 *
 * Subida de archivos al servidor propio vía /api/upload.php.
 */

import { h } from '@core/dom.js'
import { showToast } from './adminHelpers.js'

/** Sube un archivo y devuelve la URL pública */
export async function uploadFile(file, folder = 'negocios') {
    const fd = new FormData()
    fd.append('file', file)
    fd.append('folder', folder)

    const res = await fetch('/api/upload.php', { method: 'POST', body: fd })
    const data = await res.json()
    if (!res.ok || !data.ok) throw new Error(data?.error || `Error ${res.status}`)
    return data.url
}

/**
 * Crea un botón 📤 que sube archivo(s) y escribe la URL en el input.
 * - input normal  → reemplaza el valor
 * - textarea      → agrega cada URL en una línea nueva (galería)
 */
export function uploadButton(inputEl, { accept = 'image/*', multiple = false } = {}) {
    const fileInput = h('input', {
        type: 'file',
        accept,
        style: 'display:none'
    })
    if (multiple) fileInput.multiple = true

    const btn = h('button', {
        className: 'adm-btn adm-btn--ghost',
        type: 'button',
        title: 'Subir archivo',
        style: 'flex-shrink:0'
    }, '📤 Subir')

    btn.addEventListener('click', () => fileInput.click())

    fileInput.addEventListener('change', async () => {
        const files = [...fileInput.files]
        if (!files.length) return

        btn.disabled = true
        btn.textContent = '⏳…'

        try {
            for (const [i, file] of files.entries()) {
                btn.textContent = files.length > 1 ? `⏳ ${i + 1}/${files.length}` : '⏳…'
                const url = await uploadFile(file)
                if (inputEl.tagName === 'TEXTAREA') {
                    inputEl.value = inputEl.value.trim()
                        ? inputEl.value.trim() + '\n' + url
                        : url
                } else {
                    inputEl.value = url
                }
            }
            showToast(`✅ ${files.length > 1 ? files.length + ' archivos subidos' : 'Archivo subido'}`)
        } catch (err) {
            showToast(`❌ Error al subir: ${err.message}`, 4000)
        } finally {
            btn.disabled = false
            btn.textContent = '📤 Subir'
            fileInput.value = ''
        }
    })

    return h('div', { style: 'display:flex;gap:.4rem;align-items:flex-start' },
        h('div', { style: 'flex:1' }, inputEl),
        btn,
        fileInput
    )
}
